import "../CSS/ticketParrilla.css";
import React, { useRef, useEffect, useState, Fragment } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { useLocation } from "react-router-dom";
import axios from "axios";

function TicketParrilla(props) {
  const {
    nombre,
    fecha,
    nombreParticipante,
    asientos,
    id,
    idTicket,
    handleConvert,
    fechaReserva,
    numeroParticipantes,
    zona,
    estadoPago,
	categoriasEdad,
	observaciones,
	montoTotal
  } = props;
  const [url, setUrl] = useState("");
  const [shortUrl, setShortUrl] = useState("");
  const [fechaMejorada, setFechaMejorada] = useState("");

  const downloadQRCode = (e) => {
    e.preventDefault();
    setUrl("");
  };

  const qrCodeEncoder = (e) => {
    setUrl(e.target.value);
  };
  const location = useLocation();
  const handleShortenUrl = async () => {
    try {
      const response = await axios.get(
        `https://tinyurl.com/api-create.php?url=${encodeURIComponent(
          window.location.href
        )}`
      );
      setShortUrl(response.data.replace("https://", ""));
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const qrcode = (
    <QRCodeCanvas
      style={{ marginTop: "10px" }}
      id="qrCode"
      value={`${shortUrl}`}
      size={100}
      bgColor={"#ffffff"}
      level={"H"}
    />
  );
  useEffect(() => {
    handleShortenUrl();
    const opcionesDeFormato = {
      day: "numeric",
      month: "long",
      year: "numeric",
    };

    setFechaMejorada(
      new Date(fecha + "T17:00:00Z").toLocaleString("es-ES", opcionesDeFormato)
    );
  }, []);
  useEffect(() => {
    handleConvert();
  }, [shortUrl]);
  return (
    <div className="cardWrap">
      <div className="card cardLeft">
        <div className="cabecera">
          <img className="logo" src={require("../img/logo_cip.png")} />
          <h1 className="titulo-cabecera">
            <span>COLEGIOS DE INGENIEROS DEL PERU</span>
            <br />
            <span>CONSEJO DEPARTAMENTAL AREQUIPA</span>
            <br />
          </h1>
        </div>

        <div className="nameTicket">
          <h2>{nombreParticipante}</h2>
          <span>Nombre Del Participante</span>
        </div>
        <div className="title">
          <h2>{zona}</h2>
          <span>Zona de parrilla</span>
        </div>
		
        <div className="title">
          <h2>{fechaMejorada}</h2>
          <span>Fecha de reservación</span>
        </div>
		<div className="title">
          <h2>{estadoPago}</h2>
          <span>Estado de pago</span>
        </div>
		<div className="seat">
		{observaciones== ""?  <h2>Ninguna</h2> :
			  <h2>{observaciones}</h2> }
          <span>Observaciones</span>
        </div>
      </div>
      <div className="card cardRight">
        <div className="card-eye">
          <h1 className="titulo-cabecera">
            <span>Fecha de emision</span>
            <br />
            <span>{fechaReserva.split(",")[0]}</span>
            <br />
          </h1>
        </div>
        <div className="card-eye">
          <div>{qrcode}</div>
          <div className="number">
            <h3 className="numberAsientos"></h3>
            <span style={{fontWeight:"bold"}}> {numeroParticipantes} Invitado(s)</span>
			<span style={{height:"8px"}} >&nbsp;&nbsp;</span>

			<span style={{fontSize:"14px"}}> {categoriasEdad}</span>
			<span style={{height:"8px"}} >&nbsp;&nbsp;</span>

            <span>(S/.{montoTotal})</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TicketParrilla;
